// Miky Motorsport - kariera: serie a eventy (M4)
// Jedna trat zatim (oval); rozmanitost pres kola / obtiznost / pocet AI / odmeny.
// Vyssi tridy (A/S/X) se otevrou s dalsimi auty (M6). S jednim startovnim autem
// se da projet arc D -> C -> B (PI ~92 az ~194 plne vylepsene).

// Obtiznostni presety - skaluji tempo AI (pace), zakladni skill a rubber-band.
// pace primo skaluje cilovou rychlost AI v zatackach i na rovinkach.
// throttle = "agresivita" AI (skaluje plyn) - hlavni paka tempa na mirnem oválu,
// kde jsou auta limitovana zrychlenim, ne gripem v zatackach.
export const DIFFICULTY = {
  easy: { id: 'easy', label: 'Lehká', aiSkill: 0.55, pace: 0.66, throttle: 0.62, rubberK: 0.0009, reward: 0.9 },
  medium: { id: 'medium', label: 'Střední', aiSkill: 0.80, pace: 0.88, throttle: 0.88, rubberK: 0.0006, reward: 1.0 },
  hard: { id: 'hard', label: 'Těžká', aiSkill: 0.96, pace: 1.0, throttle: 1.0, rubberK: 0.0004, reward: 1.3 },
};

// Eventy: mode = typ zavodu (circuit/sprint/duel/elimination/pursuit). Mix typu = pestrost.
export const CAREER = [
  {
    id: 'rookie',
    name: 'Rookie Cup',
    klass: 'D',
    minPI: 0,
    track: 'apex_ring',
    desc: 'První brázdy na okruhu Apex Ring. Osahej si auto a poznej všechny typy závodů.',
    events: [
      { id: 'rk1', name: 'Zahřívací kolo', mode: 'circuit', laps: 2, difficulty: 'easy', numAI: 3, reward: 1.0 },
      { id: 'rk2', name: 'Sprint nováčků', mode: 'sprint', laps: 1, difficulty: 'easy', numAI: 4, reward: 1.05 },
      { id: 'rk3', name: 'Duel: Dust', mode: 'duel', laps: 2, difficulty: 'medium', numAI: 1, reward: 1.15, rival: 'Dust' },
      { id: 'rk4', name: 'Stíhačka', mode: 'pursuit', laps: 2, difficulty: 'easy', numAI: 4, reward: 1.2 },
      { id: 'rk5', name: 'Eliminace', mode: 'elimination', laps: 4, difficulty: 'easy', numAI: 4, reward: 1.25 },
      { id: 'rk6', name: 'Rookie finále', mode: 'circuit', laps: 3, difficulty: 'medium', numAI: 4, reward: 1.4, rival: 'Dust' },
    ],
  },
  {
    id: 'clubsport',
    name: 'Clubsport Series',
    klass: 'C',
    minPI: 110,
    track: 'coastal_sweep',
    desc: 'Klubové závody na rychlém pobřežním okruhu. Tady už musíš mít auto vyladěné.',
    events: [
      { id: 'cs1', name: 'Klubový sprint', mode: 'sprint', laps: 1, difficulty: 'medium', numAI: 4, reward: 1.1 },
      { id: 'cs2', name: 'Pobřežní stíhačka', mode: 'pursuit', laps: 2, difficulty: 'medium', numAI: 5, reward: 1.2 },
      { id: 'cs3', name: 'Duel: Vento', mode: 'duel', laps: 3, difficulty: 'medium', numAI: 1, reward: 1.3, rival: 'Vento' },
      { id: 'cs4', name: 'Vytrvalost', mode: 'circuit', laps: 4, difficulty: 'medium', numAI: 5, reward: 1.35 },
      { id: 'cs5', name: 'Eliminace', mode: 'elimination', laps: 4, difficulty: 'hard', numAI: 4, reward: 1.4 },
      { id: 'cs6', name: 'Clubsport finále', mode: 'circuit', laps: 4, difficulty: 'hard', numAI: 5, reward: 1.6, rival: 'Vento' },
    ],
  },
  {
    id: 'highland',
    name: 'Highland Series',
    klass: 'B',
    minPI: 150,
    track: 'highland_loop',
    championship: true,
    desc: 'Šampionát v horách za svítání - body se sčítají napříč celou sérií.',
    events: [
      { id: 'hl1', name: 'Highland sprint', mode: 'sprint', track: 'highland_loop', laps: 1, difficulty: 'medium', numAI: 5, reward: 1.2 },
      { id: 'hl2', name: 'Podzimní stíhačka', mode: 'pursuit', track: 'autumn_ridge', laps: 2, difficulty: 'medium', numAI: 5, reward: 1.3 },
      { id: 'hl3', name: 'Údolní závod', mode: 'circuit', track: 'pine_valley', laps: 3, difficulty: 'medium', numAI: 5, reward: 1.35 },
      { id: 'hl4', name: 'Duel: Vento', mode: 'duel', track: 'highland_loop', laps: 3, difficulty: 'hard', numAI: 1, reward: 1.4, rival: 'Vento' },
      { id: 'hl5', name: 'Eliminace v listí', mode: 'elimination', track: 'autumn_ridge', laps: 4, difficulty: 'hard', numAI: 4, reward: 1.5 },
      { id: 'hl6', name: 'Highland mistrák', mode: 'circuit', track: 'highland_loop', laps: 4, difficulty: 'hard', numAI: 5, reward: 1.6 },
      { id: 'hl7', name: 'Highland finále', mode: 'circuit', track: 'autumn_ridge', laps: 4, difficulty: 'hard', numAI: 5, reward: 1.8, rival: 'Brutus' },
    ],
  },
  {
    id: 'pro',
    name: 'Pro Masters',
    klass: 'B',
    minPI: 160,
    track: 'dune_speedway',
    desc: 'Mistrovská třída na pouštní speedway. Jen ti nejlepší dojedou na bednu.',
    events: [
      { id: 'pr1', name: 'Pouštní sprint', mode: 'sprint', laps: 1, difficulty: 'hard', numAI: 5, reward: 1.3 },
      { id: 'pr2', name: 'Stíhačka v dunách', mode: 'pursuit', laps: 2, difficulty: 'hard', numAI: 5, reward: 1.4 },
      { id: 'pr3', name: 'Duel: Brutus', mode: 'duel', laps: 3, difficulty: 'hard', numAI: 1, reward: 1.5, rival: 'Brutus' },
      { id: 'pr4', name: 'Eliminace', mode: 'elimination', laps: 4, difficulty: 'hard', numAI: 4, reward: 1.5 },
      { id: 'pr5', name: 'Mistrovský závod', mode: 'circuit', laps: 4, difficulty: 'hard', numAI: 5, reward: 1.6 },
      { id: 'pr6', name: 'Pro finále', mode: 'circuit', laps: 5, difficulty: 'hard', numAI: 5, reward: 1.9, rival: 'Falko' },
    ],
  },
  {
    id: 'night',
    name: 'Neon Masters',
    klass: 'A',
    minPI: 200,
    track: 'neon_mile',
    desc: 'Noční mistrovství pod neony města. Tady se rodí Legendy Miky.',
    events: [
      { id: 'nt1', name: 'Neonový sprint', mode: 'sprint', track: 'neon_mile', laps: 1, difficulty: 'hard', numAI: 5, reward: 1.5 },
      { id: 'nt2', name: 'Přístavní stíhačka', mode: 'pursuit', track: 'harbor_night', laps: 2, difficulty: 'hard', numAI: 5, reward: 1.6 },
      { id: 'nt3', name: 'Noční eliminace', mode: 'elimination', track: 'neon_mile', laps: 4, difficulty: 'hard', numAI: 4, reward: 1.7 },
      { id: 'nt4', name: 'Duel: Falko', mode: 'duel', track: 'twin_spire', laps: 3, difficulty: 'hard', numAI: 1, reward: 1.8, rival: 'Falko' },
      { id: 'nt5', name: 'Souboj věží', mode: 'circuit', track: 'twin_spire', laps: 4, difficulty: 'hard', numAI: 5, reward: 1.9 },
      { id: 'nt6', name: 'Neon finále', mode: 'circuit', track: 'neon_mile', laps: 5, difficulty: 'hard', numAI: 5, reward: 2.0, rival: 'Vento' },
    ],
  },
  {
    id: 'apex',
    name: 'Apex League',
    klass: 'A',
    minPI: 200,
    track: 'canyon_run',
    desc: 'Liga A - rychlé pouštní a pobřežní okruhy pro nejlepší.',
    events: [
      { id: 'ap1', name: 'Kaňonový sprint', mode: 'sprint', track: 'canyon_run', laps: 1, difficulty: 'hard', numAI: 5, reward: 1.5 },
      { id: 'ap2', name: 'Stíhačka v míse', mode: 'pursuit', track: 'speed_bowl', laps: 2, difficulty: 'hard', numAI: 5, reward: 1.6 },
      { id: 'ap3', name: 'Pobřežní eliminace', mode: 'elimination', track: 'bay_circuit', laps: 4, difficulty: 'hard', numAI: 4, reward: 1.7 },
      { id: 'ap4', name: 'Duel: Apex', mode: 'duel', track: 'canyon_run', laps: 3, difficulty: 'hard', numAI: 1, reward: 1.7, rival: 'Apex' },
      { id: 'ap5', name: 'Speed Bowl 500', mode: 'circuit', track: 'speed_bowl', laps: 4, difficulty: 'hard', numAI: 5, reward: 1.8 },
      { id: 'ap6', name: 'Bay mistrák', mode: 'circuit', track: 'bay_circuit', laps: 4, difficulty: 'hard', numAI: 5, reward: 1.9 },
      { id: 'ap7', name: 'Apex finále', mode: 'circuit', track: 'canyon_run', laps: 5, difficulty: 'hard', numAI: 5, reward: 2.1, rival: 'Falko' },
    ],
  },
  {
    id: 'grand',
    name: 'Grand Championship',
    klass: 'S',
    minPI: 270,
    track: 'neon_mile',
    championship: true,
    desc: 'Vrcholný šampionář napříč všemi prostředími. Tady se rodí Legenda Miky.',
    events: [
      { id: 'gc1', name: 'Neonový mistrák', mode: 'circuit', track: 'neon_mile', laps: 3, difficulty: 'hard', numAI: 5, reward: 1.8 },
      { id: 'gc2', name: 'Pouštní sprint', mode: 'sprint', track: 'speed_bowl', laps: 1, difficulty: 'hard', numAI: 5, reward: 1.7 },
      { id: 'gc3', name: 'Eliminace věží', mode: 'elimination', track: 'twin_spire', laps: 4, difficulty: 'hard', numAI: 4, reward: 1.9 },
      { id: 'gc4', name: 'Dunová stíhačka', mode: 'pursuit', track: 'dune_speedway', laps: 2, difficulty: 'hard', numAI: 5, reward: 1.9 },
      { id: 'gc5', name: 'Duel: Brutus', mode: 'duel', track: 'harbor_night', laps: 3, difficulty: 'hard', numAI: 1, reward: 2.0, rival: 'Brutus' },
      { id: 'gc6', name: 'Kaňonový mistrák', mode: 'circuit', track: 'canyon_run', laps: 4, difficulty: 'hard', numAI: 5, reward: 2.1 },
      { id: 'gc7', name: 'Grand Finále', mode: 'circuit', track: 'neon_mile', laps: 5, difficulty: 'hard', numAI: 5, reward: 2.6, rival: 'Falko', finale: true },
    ],
  },
];

// Bodovani sampionatu (F1-style) podle pozice (1-based) - pro serie s championship:true.
export const CHAMPIONSHIP_POINTS = [25, 18, 15, 12, 10, 8, 6, 4, 2, 1];
export function championshipPoints(position) {
  return CHAMPIONSHIP_POINTS[position - 1] || 0;
}

// Plochy seznam vsech eventu + index serie (pomocnik)
const EVENT_INDEX = {};
for (const s of CAREER) {
  s.events.forEach((e, i) => {
    EVENT_INDEX[e.id] = { event: e, series: s, idx: i };
  });
}

export function findEvent(eventId) {
  return EVENT_INDEX[eventId] || null;
}

export function difficultyOf(event) {
  return DIFFICULTY[event.difficulty] || DIFFICULTY.medium;
}
